import {
  Shield,
  ShieldCheck,
  Calendar,
  Mail,
  FileText,
  Folder,
  Sparkles,
  Wrench,
  Bot,
  Users,
  Search,
  type LucideIcon,
} from 'lucide-react';

// Curated allowlist so we get tree-shaking instead of pulling every lucide
// icon. Add new entries here when a new app's icon name lands; unknown names
// fall back to Shield so the UI never blows up. Keys are the kebab-case names
// stored in the `apps.icon` column and returned by the manifest.
const TILE_ICONS: Record<string, LucideIcon> = {
  shield: Shield,
  'shield-keyhole': ShieldCheck,
  'shield-check': ShieldCheck,
  calendar: Calendar,
  mail: Mail,
  'file-text': FileText,
  folder: Folder,
  sparkles: Sparkles,
  wrench: Wrench,
  bot: Bot,
  users: Users,
  search: Search,
};

export function resolveAppIcon(name: string): LucideIcon {
  return TILE_ICONS[name] ?? Shield;
}
